var map = {
	"./banner_video_bg": 6,
	"./banner_video_bg.png": 6,
	"./check": 7,
	"./check.svg": 7,
	"./chevron-down": 8,
	"./chevron-down.svg": 8,
	"./chevrons-down": 9,
	"./chevrons-down.svg": 9,
	"./chevrons-left": 10,
	"./chevrons-left.svg": 10,
	"./chevrons-right": 11,
	"./chevrons-right.svg": 11,
	"./chevrons-up": 12,
	"./chevrons-up.svg": 12,
	"./close": 13,
	"./close.png": 13,
	"./course/1": 14,
	"./course/1.png": 14,
	"./course/2": 15,
	"./course/2.png": 15,
	"./course/3": 16,
	"./course/3.png": 16,
	"./course/4": 17,
	"./course/4.png": 17,
	"./course/5": 18,
	"./course/5.png": 18,
	"./course/6": 19,
	"./course/6.png": 19,
	"./course/7": 20,
	"./course/7.png": 20,
	"./course/__depo_01": 21,
	"./course/__depo_01.png": 21,
	"./course/__depo_02": 22,
	"./course/__depo_02.png": 22,
	"./course/__depo_03": 23,
	"./course/__depo_03.png": 23,
	"./course/__depo_04": 24,
	"./course/__depo_04.png": 24,
	"./course/aula_01": 25,
	"./course/aula_01.png": 25,
	"./course/aula_01__": 26,
	"./course/aula_01__.png": 26,
	"./course/aula_06": 27,
	"./course/aula_06.png": 27,
	"./course/aula_06__": 28,
	"./course/aula_06__.png": 28,
	"./course/certificado": 29,
	"./course/certificado.png": 29,
	"./course/certificado___": 30,
	"./course/certificado___.png": 30,
	"./course/certificado_bg": 31,
	"./course/certificado_bg.png": 31,
	"./course/course_bg": 32,
	"./course/course_bg.png": 32,
	"./course/depo_01": 33,
	"./course/depo_01.png": 33,
	"./course/depo_02": 34,
	"./course/depo_02.png": 34,
	"./course/depo_03": 35,
	"./course/depo_03.png": 35,
	"./course/depo_04": 36,
	"./course/depo_04.png": 36,
	"./course/fausto_banner": 37,
	"./course/fausto_banner.png": 37,
	"./course/terminal": 38,
	"./course/terminal.png": 38,
	"./course/terminal__": 39,
	"./course/terminal__.png": 39,
	"./ecalls/01_header_arrow_up": 40,
	"./ecalls/01_header_arrow_up.png": 40,
	"./ecalls/01_header_banner_bottom": 41,
	"./ecalls/01_header_banner_bottom.png": 41,
	"./ecalls/02_why_e_calls_logo_bg": 42,
	"./ecalls/02_why_e_calls_logo_bg.png": 42,
	"./ecalls/02_why_e_calls_logo_bg_2": 43,
	"./ecalls/02_why_e_calls_logo_bg_2.png": 43,
	"./ecalls/03_reasons_convenience": 44,
	"./ecalls/03_reasons_convenience.png": 44,
	"./ecalls/03_reasons_market": 45,
	"./ecalls/03_reasons_market.png": 45,
	"./ecalls/03_reasons_opportunities": 46,
	"./ecalls/03_reasons_opportunities.png": 46,
	"./ecalls/03_reasons_position_size": 47,
	"./ecalls/03_reasons_position_size.png": 47,
	"./ecalls/03_reasons_prob": 48,
	"./ecalls/03_reasons_prob.png": 48,
	"./ecalls/03_reasons_risk": 49,
	"./ecalls/03_reasons_risk.png": 49,
	"./ecalls/03_reasons_timing": 50,
	"./ecalls/03_reasons_timing.png": 50,
	"./ecalls/03_reasons_understanding": 51,
	"./ecalls/03_reasons_understanding.png": 51,
	"./ecalls/04_how_it_works_1": 52,
	"./ecalls/04_how_it_works_1.png": 52,
	"./ecalls/04_how_it_works_2": 53,
	"./ecalls/04_how_it_works_2.png": 53,
	"./ecalls/04_how_it_works_3": 54,
	"./ecalls/04_how_it_works_3.png": 54,
	"./ecalls/04_how_it_works_bitcoin_wings": 55,
	"./ecalls/04_how_it_works_bitcoin_wings.png": 55,
	"./ecalls/05_market_signs_enfoque_bg": 56,
	"./ecalls/05_market_signs_enfoque_bg.png": 56,
	"./ecalls/05_market_signs_side_details": 57,
	"./ecalls/05_market_signs_side_details.png": 57,
	"./ecalls/06_fausto_e_logo": 58,
	"./ecalls/06_fausto_e_logo.png": 58,
	"./ecalls/06_fausto_frame_cloud_bottom": 59,
	"./ecalls/06_fausto_frame_cloud_bottom.png": 59,
	"./ecalls/06_fausto_frame_cloud_top": 60,
	"./ecalls/06_fausto_frame_cloud_top.png": 60,
	"./ecalls/06_fausto_gradient_bg": 61,
	"./ecalls/06_fausto_gradient_bg.png": 61,
	"./ecalls/bitcoin_dinner": 62,
	"./ecalls/bitcoin_dinner.png": 62,
	"./ecalls/bitcoin_dolar_fundo": 63,
	"./ecalls/bitcoin_dolar_fundo.png": 63,
	"./ecalls/bitcoin_people": 64,
	"./ecalls/bitcoin_people.png": 64,
	"./ecalls/card_star_tag": 65,
	"./ecalls/card_star_tag.png": 65,
	"./ecalls/fausto_botelho_bitcoin": 66,
	"./ecalls/fausto_botelho_bitcoin.png": 66,
	"./ecalls/fausto_video": 67,
	"./ecalls/fausto_video.png": 67,
	"./ecalls/footer_bitcoin_bottom": 68,
	"./ecalls/footer_bitcoin_bottom.png": 68,
	"./ecalls/guaranteed_badge_pt": 69,
	"./ecalls/guaranteed_badge_pt.png": 69,
	"./ecalls/happy_with_bitcoin": 70,
	"./ecalls/happy_with_bitcoin.png": 70,
	"./ecalls/icon_checked_circle_grey": 71,
	"./ecalls/icon_checked_circle_grey.png": 71,
	"./ecalls/icon_checked_circle_ice": 1,
	"./ecalls/icon_checked_circle_ice.png": 1,
	"./ecalls/icon_checked_circle_orange": 72,
	"./ecalls/icon_checked_circle_orange.png": 72,
	"./ecalls/icon_chevron_down_ice": 73,
	"./ecalls/icon_chevron_down_ice.png": 73,
	"./ecalls/icon_circle_orange": 2,
	"./ecalls/icon_circle_orange.png": 2,
	"./ecalls/icon_clock_ice": 74,
	"./ecalls/icon_clock_ice.png": 74,
	"./ecalls/icon_monitor_ice": 75,
	"./ecalls/icon_monitor_ice.png": 75,
	"./ecalls/metodo_dealer": 76,
	"./ecalls/metodo_dealer.png": 76,
	"./enfoque": 77,
	"./enfoque.png": 77,
	"./facebook": 78,
	"./facebook.png": 78,
	"./faustobotelho": 79,
	"./faustobotelho.png": 79,
	"./fbcalls/3": 80,
	"./fbcalls/3.png": 80,
	"./fbcalls/4": 81,
	"./fbcalls/4.png": 81,
	"./fbcalls/5": 82,
	"./fbcalls/5.png": 82,
	"./fbcalls/6": 83,
	"./fbcalls/6.png": 83,
	"./fbcalls/7": 84,
	"./fbcalls/7.png": 84,
	"./fbcalls/8": 85,
	"./fbcalls/8.png": 85,
	"./fbcalls/___recomendacao": 86,
	"./fbcalls/___recomendacao.png": 86,
	"./fbcalls/banner_hero": 87,
	"./fbcalls/banner_hero.png": 87,
	"./fbcalls/banner_topo": 88,
	"./fbcalls/banner_topo.jpg": 88,
	"./fbcalls/bg_intro": 89,
	"./fbcalls/bg_intro.png": 89,
	"./fbcalls/binance": 90,
	"./fbcalls/binance.png": 90,
	"./fbcalls/bitget": 91,
	"./fbcalls/bitget.png": 91,
	"./fbcalls/btc_for_bg": 92,
	"./fbcalls/btc_for_bg.png": 92,
	"./fbcalls/bull_vs_bear_bg": 93,
	"./fbcalls/bull_vs_bear_bg.png": 93,
	"./fbcalls/bybit": 94,
	"./fbcalls/bybit.png": 94,
	"./fbcalls/coinbase": 95,
	"./fbcalls/coinbase.jpg": 95,
	"./fbcalls/fb_for_bg": 96,
	"./fbcalls/fb_for_bg.png": 96,
	"./fbcalls/fbcalls_banner_bg": 97,
	"./fbcalls/fbcalls_banner_bg.png": 97,
	"./fbcalls/fbcalls_logo": 98,
	"./fbcalls/fbcalls_logo.png": 98,
	"./fbcalls/fbcalls_o_que_e": 99,
	"./fbcalls/fbcalls_o_que_e.png": 99,
	"./fbcalls/gold_to_blue_transition": 100,
	"./fbcalls/gold_to_blue_transition.jpg": 100,
	"./fbcalls/kraken": 3,
	"./fbcalls/kraken.jpg": 163,
	"./fbcalls/kraken.png": 3,
	"./fbcalls/recomendacao": 101,
	"./fbcalls/recomendacao.png": 101,
	"./fbcalls/telegram": 102,
	"./fbcalls/telegram.png": 102,
	"./fbcalls/thumbnail_playlist": 103,
	"./fbcalls/thumbnail_playlist.jpg": 103,
	"./fbcalls_positive": 104,
	"./fbcalls_positive.png": 104,
	"./home/3": 105,
	"./home/3.png": 105,
	"./home/4": 106,
	"./home/4.png": 106,
	"./home/5": 107,
	"./home/5.png": 107,
	"./home/6": 108,
	"./home/6.png": 108,
	"./home/7": 109,
	"./home/7.png": 109,
	"./home/8": 110,
	"./home/8.png": 110,
	"./home/banner_bg": 111,
	"./home/banner_bg.png": 111,
	"./home/banner_bg___": 112,
	"./home/banner_bg___.png": 112,
	"./home/curso": 113,
	"./home/curso.png": 113,
	"./home/fausto": 114,
	"./home/fausto.png": 114,
	"./home/fausto_btc": 115,
	"./home/fausto_btc.png": 115,
	"./home/fausto_btc___": 116,
	"./home/fausto_btc___.png": 116,
	"./home/fb_logo": 117,
	"./home/fb_logo.png": 117,
	"./home/home_banner": 4,
	"./home/home_banner.jpg": 164,
	"./home/home_banner.png": 4,
	"./home/light_bg": 118,
	"./home/light_bg.png": 118,
	"./home/marketposter_cripto": 119,
	"./home/marketposter_cripto.png": 119,
	"./home/marketposter_ind_americano": 120,
	"./home/marketposter_ind_americano.png": 120,
	"./home/marketposter_ind_brasileiro": 121,
	"./home/marketposter_ind_brasileiro.png": 121,
	"./home/marketposters_banner": 122,
	"./home/marketposters_banner.png": 122,
	"./home/marketposters_logo": 123,
	"./home/marketposters_logo.png": 123,
	"./home/marketposters_logo__": 124,
	"./home/marketposters_logo__.png": 124,
	"./home/marketposters_logo_____": 125,
	"./home/marketposters_logo_____.png": 125,
	"./home/motivacao_bg": 126,
	"./home/motivacao_bg.jpg": 126,
	"./home/rentabilidade": 127,
	"./home/rentabilidade.png": 127,
	"./home/rentabilidade__": 128,
	"./home/rentabilidade__.png": 128,
	"./instagram": 129,
	"./instagram.png": 129,
	"./menu": 130,
	"./menu.svg": 130,
	"./pages/facebook": 131,
	"./pages/facebook.png": 131,
	"./pages/facebook_white": 132,
	"./pages/facebook_white.png": 132,
	"./pages/fausto_botelho_main_pic": 133,
	"./pages/fausto_botelho_main_pic.png": 133,
	"./pages/home_fausto_pic": 134,
	"./pages/home_fausto_pic.jpg": 134,
	"./pages/instagram": 135,
	"./pages/instagram.png": 135,
	"./pages/instagram_white": 136,
	"./pages/instagram_white.png": 136,
	"./pages/linkedin": 137,
	"./pages/linkedin.png": 137,
	"./pages/linkedin_white": 138,
	"./pages/linkedin_white.png": 138,
	"./pages/telegram": 139,
	"./pages/telegram.png": 139,
	"./pages/telegram_white": 140,
	"./pages/telegram_white.png": 140,
	"./pages/twitter": 141,
	"./pages/twitter.png": 141,
	"./pages/twitter_white": 142,
	"./pages/twitter_white.png": 142,
	"./pages/youtube": 143,
	"./pages/youtube.png": 143,
	"./pages/youtube_white": 144,
	"./pages/youtube_white.png": 144,
	"./play-button": 145,
	"./play-button.png": 145,
	"./red_arrow": 146,
	"./red_arrow.png": 146,
	"./staff_feature": 147,
	"./staff_feature.jpg": 147,
	"./telegram": 148,
	"./telegram.png": 148,
	"./twitter": 149,
	"./twitter.png": 149,
	"./video_ecalls_thumb": 150,
	"./video_ecalls_thumb.jpg": 150,
	"./whatsapp_white": 151,
	"./whatsapp_white.png": 151,
	"./youtube": 152,
	"./youtube.png": 152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 162;